// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as CardsSDK$OrcaPaymentPage from "./CardsSDK.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as VaultHelpers$OrcaPaymentPage from "./VaultHelpers.bs.js";
import * as SecureCardCvcField$OrcaPaymentPage from "./SecureCardCvcField.bs.js";
import * as PaymentSurfaceFamily$OrcaPaymentPage from "../Utilities/PaymentSurfaceFamily.bs.js";
import * as SecureCardExpiryField$OrcaPaymentPage from "./SecureCardExpiryField.bs.js";
import * as SecureCardNumberField$OrcaPaymentPage from "./SecureCardNumberField.bs.js";

let InvalidSurfaceFamilyParams = /* @__PURE__ */Primitive_exceptions.create("PaymentMethodsSDK-OrcaPaymentPage.InvalidSurfaceFamilyParams");

function PaymentMethodsSDK(props) {
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let sessions = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.sessions);
  let setVaultCredentials = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.vaultCredentials);
  let isConfigReady = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isConfigReady);
  let isSavedCardCvcFlow = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isSavedCardCvcFlow);
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match.themeObj;
  let componentName = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  let fieldNameStr = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "fieldName");
  let surfaceFamilyStr = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "surfaceFamily");
  let fieldName = fieldNameStr === "" ? undefined : fieldNameStr;
  let surfaceFamily = surfaceFamilyStr === "" ? undefined : surfaceFamilyStr;
  let family = PaymentSurfaceFamily$OrcaPaymentPage.classifyFromUrlParams(componentName, surfaceFamily);
  React.useEffect(() => {
    if (family === "VaultFamily") {
      setVaultCredentials(param => VaultHelpers$OrcaPaymentPage.getVaultCredentialsFromSessions(sessions));
    }
  }, [
    family,
    sessions
  ]);
  let tmp;
  let exit = 0;
  let unknownField;
  switch (family) {
    case "VaultFamily" :
      if (fieldName !== undefined) {
        switch (fieldName) {
          case "cardCvc" :
            tmp = JsxRuntime.jsx(SecureCardCvcField$OrcaPaymentPage.make, {});
            break;
          case "cardExpiry" :
            tmp = JsxRuntime.jsx(SecureCardExpiryField$OrcaPaymentPage.make, {});
            break;
          case "cardNumber" :
            tmp = JsxRuntime.jsx(SecureCardNumberField$OrcaPaymentPage.make, {});
            break;
          default:
            unknownField = fieldName;
            exit = 1;
        }
      } else {
        tmp = JsxRuntime.jsx(CardsSDK$OrcaPaymentPage.make, {
          cvcOnly: isSavedCardCvcFlow
        });
      }
      break;
    case "PaymentsFamily" :
      if (fieldName !== undefined) {
        switch (fieldName) {
          case "cardCvc" :
            tmp = JsxRuntime.jsx(SecureCardCvcField$OrcaPaymentPage.make, {});
            break;
          case "cardExpiry" :
            tmp = JsxRuntime.jsx(SecureCardExpiryField$OrcaPaymentPage.make, {});
            break;
          case "cardNumber" :
            tmp = JsxRuntime.jsx(SecureCardNumberField$OrcaPaymentPage.make, {});
            break;
          default:
            unknownField = fieldName;
            exit = 1;
        }
      } else {
        console.warn("[PaymentMethodsSDK] PaymentsFamily with no fieldName — bundled payments surface is not wired. Treat as a bug.");
        tmp = null;
      }
      break;
    case "OtherFamily" :
      throw {
        RE_EXN_ID: InvalidSurfaceFamilyParams,
        componentName: componentName,
        surfaceFamily: Core__Option.getOr(surfaceFamily, "MISSING"),
        fieldName: Core__Option.getOr(fieldName, "MISSING"),
        Error: new Error()
      };
  }
  if (exit === 1) {
    throw {
      RE_EXN_ID: InvalidSurfaceFamilyParams,
      componentName: componentName,
      surfaceFamily: Core__Option.getOr(surfaceFamily, "MISSING"),
      fieldName: `UNKNOWN_FIELD:` + unknownField,
      Error: new Error()
    };
  }
  return JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
    condition: isConfigReady,
    children: JsxRuntime.jsx("div", {
      children: tmp,
      className: "font-medium p-0.5",
      dir: match.localeString.localeDirection,
      style: {
        color: themeObj.colorText,
        fontFamily: themeObj.fontFamily,
        fontSize: themeObj.fontSizeBase
      }
    })
  });
}

let make = PaymentMethodsSDK;

export {
  InvalidSurfaceFamilyParams,
  make,
}
/* jotai Not a pure module */
